export const achButtonsDisplay = [
    "/payment-method/wire",
    "/payment-method/wire/input-section",
];

export const NOT_ACCREDITATED = "Account not found";
export const NO_EXTERNAL_ACCOUNT = "External account not found";
export const EXTERNAL_ACCOUNT = "";
